import useSWR from 'swr';

import { generateApiPath, getItem } from '#app/Handler/api';
import { Filters } from '#app/View/Statistic/Order/StatisticOrder';
import OrderDocumentEntryPoints from '#app/entrypoints/orderDocument';
import { TaxTypeId } from '#app/typings/orderDocument';

type TotalPrice = Record<TaxTypeId, number> & {
  totalHT: number;
  totalTTC: number;
};

type HookReturn = {
  totalPrice: TotalPrice;
  loading: boolean;
};

const useStatisticOrderTotal = (filters: Filters): HookReturn => {
  const { data: totalPrice, isLoading } = useSWR<TotalPrice>(
    generateApiPath(OrderDocumentEntryPoints.getStatisticTotals, {}, filters),
    getItem,
    {
      keepPreviousData: true,
    },
  );

  return {
    totalPrice: totalPrice ?? {
      totalHT: 0,
      totalTTC: 0,
      2: 0,
      3: 0,
      5: 0,
      10: 0,
      12: 0,
      19: 0,
    },
    loading: isLoading,
  };
};

export default useStatisticOrderTotal;
